/* eslint-disable import/prefer-default-export */
const getRechargeCookie = (name) => {
  return (document.cookie.match(`(^|; )${name}=([^;]*)`) || 0)[2];
};

const getGALinkerParam = () => {
  try {
    // Cross-domain tracking with Google Analytics
    const param = ga.getAll()[0].get('linkerParam');
    return `&${param}`;
  } catch (e) {
    // 'ga' is not available
    return '';
  }
};

export const getRechargeURL = (domain, customerId, customerEmail) => {
  const token = getRechargeCookie('cart');
  const gaLinkerParam = getGALinkerParam();
  const domainParam = `&myshopify_domain=${domain}`;
  const customerParam = customerId && customerEmail ? `&customer_id=${customerId}&customer_email=${customerEmail}` : '';

  return `https://checkout.rechargeapps.com/r/checkout?cart_token=${token}${gaLinkerParam}${domainParam}${customerParam}`;
};
